import QbDiscord from './QbDiscord.vue'

export default {
  discord: {
    component: QbDiscord
  }
}
